'use client';

import { useEffect, useState } from 'react';

export type BrowserType = 'samsung' | 'naver' | 'chrome' | 'safari' | undefined;

const useBrowserCheck = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [browser, setBrowser] = useState<BrowserType>(undefined);
  const [isAndroid, setIsAndroid] = useState(false);

  const getBrowserType = (userAgent: string): BrowserType => {
    const lowerCasedUserAgent = userAgent.toLowerCase();
    if (lowerCasedUserAgent.indexOf('naver(inapp;') !== -1) return 'naver';
    if (lowerCasedUserAgent.indexOf('samsungbrowser') !== -1) return 'samsung';
    if (lowerCasedUserAgent.indexOf('chrome') !== -1) return 'chrome';
    if (lowerCasedUserAgent.indexOf('safari') !== -1) return 'safari';
    return undefined;
  };

  useEffect(() => {
    const userAgent = window.navigator.userAgent;
    if (!userAgent) return;

    setIsLoading(true);

    if (userAgent.indexOf('Android') !== -1) setIsAndroid(true);

    setBrowser(getBrowserType(userAgent));
  }, []);

  return { isLoading, browser, isAndroid };
};

export default useBrowserCheck;
